export interface ExpenseCat {
  id: number;
  imgPath: string;
  name: string;
  compte: number;
  imgColor: string;
  helpComment: string | null;
  amount: number | null;
  limited: boolean;
  bgColor: string;
  positive: boolean;
  isActive: boolean;
  attachmentRequired?: boolean;
  deleteable: boolean;
  code: number | null;
  noteId: number | null;
  expensesCatLimitsDto: ExpensesCatLimitsDto | null;
  message: string | null;
  message2: string | null;
  message3: string | null;
  type: string | null;
  usageCount: number | null;
}

interface UserImage {
  id: string;
  fullName: string;
  fonction: string | null;
  email: string | null;
  site: string | null;
  departement: string | null;
  picturePath: string;
  rolename: string | null;
  birthday: string | null;
  hiringdayV: string | null;
  hiringDay: boolean;
  managerFullName: string | null;
  displayNameRole: string | null;
}

interface ExpensesCatLimitsDto {
  type: string | null;
  amount: number | null;
  percentage: number | null;
  maxLimit: boolean;
  period: string | null;
  periodAmount: number | null;
  periodMax: string | null;
  positive: boolean;
  nbrMax: number | null;
  mileage: boolean;
  mile: number | null;
  fk_catId: number;
  catType: string | null;
}

export interface NotesFormValues {
  affectedUserId: string;
  title: string;
  currency: string;
  executionDate: string;
  description: string;
  files: File[];
  id: number | string;
  filesNames: FileType[];
  projectId: string;
}

interface UserImageN {
  id: string;
  fullName: string;
  fonction: string | null;
  email: string | null;
  site: string | null;
  departement: string | null;
  picturePath: string;
  rolename: string | null;
  birthday: string | null;
  hiringdayV: string | null;
  hiringDay: boolean;
  managerFullName: string | null;
  displayNameRole: string | null;
}

interface ExpensesCatN {
  id: number;
  imgPath: string;
  name: string;
  compte: number;
  imgColor: string;
  helpComment: string | null;
  amount: number | null;
  limited: boolean;
  bgColor: string;
  positive: boolean;
  isActive: boolean;
  deleteable: boolean;
  code: number | null;
  noteId: number | null;
  expensesCatLimitsDto: ExpensesCatLimitsDto | null;
  message: string | null;
  message2: string | null;
  message3: string | null;
  type: string | null;
  usageCount: number | null;
}

export interface ExpenseDetail {
  id: number;
  title: string;
  reference: string | null;
  category: string | null;
  date: string;
  amount: number;
  supplier: string | null;
  payedBy: string;
  tva: number | null;
  description: string | null;
  documentPath: string | null;
  fk_NoteId: number;
  fk_User: string;
  userImage: UserImageN;
  paiementType: string | null;
  files: unknown | null;
  filesContent: unknown | null;
  filesNames: FileType[];
  file: unknown | null;
  expensesCat: ExpensesCatN;
  catId: number | null;
  limitedAmount: number | null;
  infoAmount: number | null;
  currency: string;
  distance: number;
  total: number | null;
  noteStatus: NoteStatus;
}

interface Search {
  value: string | null;
  regex: boolean;
}

interface Order {
  column: string | null;
  dir: string | null;
  custom: boolean;
}

export interface NotesFilter {
  userId: string | null;
  status: string | null;
  site: string | null;
  society: string | null;
  date_created_min: string | null;
  date_created_max: string | null;
}

export interface NotesFilterDataTable {
  start: number;
  length: number;
  search: Search;
  order?: Order[];
  filters: NotesFilter;
}

export interface NoteDataItem {
  id: number;
  title: string;
  currency: string | null;
  reference: string | null;
  executionDate: string;
  status: number;
  statusText: string | null;
  description: string | null;
  affectedUserId: string;
  actionBy: string | null;
  totalExpenses: number;
  userImage: string | null;
  allExpenses: unknown[];
  history: unknown[];
  usersList: unknown | null;
  historyDate: string;
  days: number;
  actionDate: string;
  name: string;
  paiementType: string | null;
  nbrExpenses: number;
  createdDate: string | null;
  advance: number;
  totalExpenses2: string;
  currencyList: unknown | null;
  refundedBy: string | null;
  refundComment: string | null;
  approvalStatu: string | null;
  files: unknown | null;
  filesContent: unknown | null;
  filesNames: unknown | null;
  refundPeriod: string | null;
  user: SelectItem;
  comment: string | null;
  nextStatus: number | null;
}

export interface NotesDataTableResponse {
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  visible: boolean;
  data: NoteDataItem[];
}

export interface HistoryItem {
  action: number;
  actionDate: string;
  fk_UserId: string;
  fk_NoteId: number;
  userImage: UserImage;
}

export interface UserlistApproval {
  userId: string;
  fullName: string;
  level: string;
  status: string;
  picturePath: string | null;
  departement: string | null;
  actionType: string;
  actionDate: string;
}
export interface NoteDetailResponse {
  id: number;
  title: string;
  currency: string;
  reference: string | null;
  noteReference: string | null;
  executionDate: string;
  status: number;
  statusText: string | null;
  description: string;
  affectedUserId: string;
  actionBy: string;
  totalExpenses: number;
  userImage: UserImage;
  allExpenses: ExpenseDetail[];
  history: HistoryItem[];
  usersList: unknown | null;
  historyDate: string | null;
  days: number | null;
  actionDate: string | null;
  name: string | null;
  paiementType: string | null;
  nbrExpenses: number | null;
  createdDate: string;
  advance: number;
  totalExpenses2: string | null;
  currencyList: unknown | null;
  refundedBy: string | null;
  refundComment: string | null;
  approvalStatu: string;
  files: File[] | null;
  filesContent: unknown | null;
  filesNames: FileType[] | null;
  refundPeriod: number;
  user: SelectItem | null;
  comment: string | null;
  nextStatus: string;
  userslistApproval: UserlistApproval[];
  projectId?: number;
  projectName?: string;
}

interface SiteType {
  id: number;
  title: string;
  adressMap: string | null;
  country: string | null;
  fuseaHoraire: string | null;
  congeSyteme: string | null;
  totalUsers: number;
  placeLat: number | null;
  placeLng: number | null;
  placeId: string | null;
  coutries: string | null;
  holidayCalender: string | null;
  nextId: number | null;
  previousId: number | null;
}

interface SocietyType {
  id: number;
  title: string;
  adressMap: string | null;
  country: string | null;
  fuseaHoraire: string | null;
  congeSyteme: string | null;
  totalUsers: number;
  placeLat: number | null;
  placeLng: number | null;
  placeId: string | null;
  coutries: string | null;
  holidayCalender: string | null;
  nextId: number | null;
  previousId: number | null;
}

export interface ExpensesStats {
  allDraft: number;
  allPending: number;
  totalPending: number;
  allApproved: number;
  totalApproved: number;
  allRejected: number;
  totalRejected: number;
  allRefunded: number;
  totalRefunded: number;
  toltalNotes: number;
  clientCurrency: string;
  sites: SiteType[];
  societies: SocietyType[];
}

export enum NoteStatus {
  Draft = 0,
  Pending = 1,
  Success = 2,
  Refund = 3,
  Rejected = 4,
  Canceled = 5,
}

export interface ExportFilters {
  SearchValue?: string | null;
  Departement?: string | null;
  Area?: string | null;
  WorkTime?: string | null;
  Site?: string | null;
  Society?: string | null;
  Service?: string | null;
  Type?: string | null;
  Fonction?: string | null;
  Min?: string | null;
  Max?: string | null;
  OffreId?: number | null;
  DateMin?: string | null;
  DateMax?: string | null;
  date_created_max?: string | null;
  date_created_min?: string | null;
  range_min?: string | null;
  range_max?: string | null;
  range_min_profil?: string | null;
  range_max_profil?: string | null;
  Status?: string | null;
  Contrat?: string | null;
  TypeConge?: string | null;
  TypeHardware?: string | null;
  TypeSoftware?: string | null;
  DateFormat?: string | null;
  LisenceType?: string | null;
  TypeIntervention?: string | null;
  Priority?: string | null;
  NatureIntervention?: string | null;
  ids?: string[];
  idsNotSelected?: string[] | null;
  DateFinDabonnementMin?: string | null;
  DateFinDabonnementMax?: string | null;
  Country?: string | null;
  Language?: string | null;
  StatutArchive?: string | null;
  DataSourceId?: string | null;
  Collaborateur?: string | null;
  Year?: string | null;
  FilterType?: string | null;
  MaxClosureDate?: string | null;
  MinClosureDate?: string | null;
  Tag?: string | null;
  Events?: string | null;
  MonthDate?: string | null;
}

export interface SelectItem {
  value: string | null;
  text: string | null;
  smallText: string | null;
  imagePath: string | null;
  labelGroup: string | null;
  valueGroup: string | null;
  selected: boolean;
  type: string | null;
  date: string | null;
  order: number | null;
}

export interface ChangeStatus {
  id: number;
  comment?: string;
  refundedBy?: string;
  status?: NoteStatus;
  paiementTypes?: SelectItem[];
  paiementType?: string;
}

export interface ExpenseData {
  note: NoteDetailResponse;
  clientName: string | null;
  addresse: string | null;
  phoneNumber: string | null;
  city: string | null;
  country: string | null;
}
